import React from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle } from 'styled-components';
import theme from '@vr/lib/styles/theme';
import getNomeProduto from '../helpers/getNomeProduto';
import getIconByProduto from '../helpers/getIconByProduto';

const PopupGlobalStyle = createGlobalStyle`
  .gm-style .gm-style-iw-d, .gm-style .gm-style-iw-c, .gm-style .gm-style-iw {
    overflow: inherit !important;
  }
`;

const MapInfoBox = styled.div`
  width: 300px;
  font-family: Montserrat;
  padding: 3px 15px 15px 3px;
  .popup-header {
    color: ${theme.colors.gray400};
    margin-bottom: 5px;
    h3 {
      text-transform: capitalize;
      font-weight: bold !important;
      font-size: 15px !important;
      color: ${theme.colors.gray400};
      margin-bottom: 10px;
    }
    p {
      text-transform: capitalize;
      font-size: 13px !important;
      margin: 0;
      line-height: 20px;
    }
  }
  .popup-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
    span.popup-info-distancia {
      font: bold 15px/24px Montserrat;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      flex-direction: row;
    }
  }
`;

const Tooltip = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-weight: bold;
  text-align: center;
  padding: 5px;
  top: -36px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  min-width: 130px;
  border-radius: 5px;
  opacity: 0;
  visibility: hidden;
  &:after {
    content: '';
    width: 1px;
    height: 1px;
    display: block;
    border-width: 10px;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent;
    border-style: solid;
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const ContainerIconeCartao = styled.li`
  margin-right: 10px;
  position: relative;
  img {
    height: 18px;
  }
  &:hover {
    ${Tooltip} {
      opacity: 1;
      visibility: visible;
    }
  }
`;

function Popup({ estabelecimento, companyName }) {
  if (!estabelecimento) {
    return null;
  }

  function renderProdutos() {
    if (!estabelecimento.produtos || !Array.isArray(estabelecimento.produtos)) {
      return null;
    }

    return (
      <ul>
        {estabelecimento.produtos.map(code => {
          const nomeProduto = `${companyName} ${getNomeProduto(code)}`.trim();
          const iconProduto = getIconByProduto(code);
          return (
            <ContainerIconeCartao key={String(code)}>
              <img src={iconProduto} alt={nomeProduto} title={nomeProduto} />
              <Tooltip>{nomeProduto}</Tooltip>
            </ContainerIconeCartao>
          );
        })}
      </ul>
    );
  }

  return (
    <>
      <MapInfoBox>
        <div className="popup-header">
          <h3>{String(estabelecimento.nome).toLowerCase()}</h3>
          <p>
            {String(estabelecimento.endereco).toLowerCase()}
            <br />
            {String(estabelecimento.cidade).toLowerCase()} -{' '}
            {estabelecimento.estado}
          </p>
        </div>
        <div className="popup-footer">{renderProdutos()}</div>
      </MapInfoBox>
      <PopupGlobalStyle />
    </>
  );
}

Popup.propTypes = {
  estabelecimento: PropTypes.shape({
    nome: PropTypes.string,
    endereco: PropTypes.string,
    cidade: PropTypes.string,
    estado: PropTypes.string,
    produtos: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.arrayOf(PropTypes.number),
    ]),
    latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
  companyName: PropTypes.string,
};

Popup.defaultProps = {
  estabelecimento: null,
  center: null,
  companyName: '',
};

export default Popup;
